import { gql } from "@apollo/client";

const INBOX_DETAIL_ADDED = gql`
  subscription InboxDetailAdded {
    inboxdetailadded {
      id
      inboxId
      customerName
      customerPicture
      source
      chatorder
      messageId
      messagetext
      messagetimestamp
      read
      marknottoaddinchatcircle
      labels
      agentId
      salesDone
      customerId
      pageId
      pageName
      accesstoken
      chatLosingAgentId
    }
  }
`;

export default INBOX_DETAIL_ADDED;
